/* Day One — Electrolyte LP v4. Tiny vanilla JS, no jQuery, no deps. */
(function () {
  "use strict";
  var root = document.querySelector(".lp-el");
  if (!root) return;

  // --- Reveal-on-scroll ---
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-revealed");
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    root.querySelectorAll("[data-reveal]").forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("is-revealed"); });
  }

  // --- FAQ accordion ---
  root.querySelectorAll(".lp-el__faq-item").forEach(function (item) {
    var btn = item.querySelector(".lp-el__faq-q");
    if (!btn) return;
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var open = item.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  // --- Email form guard ---
  var form = root.querySelector(".lp-el__email-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      var input = form.querySelector('input[type="email"]');
      if (!input || !input.value || input.value.indexOf("@") < 0) {
        e.preventDefault();
        input && input.focus();
      }
    });
  }

  // --- Sticky mobile CTA: show after hero scrolls past, hide near footer/final CTA ---
  var stickybar = document.getElementById("lp-stickybar");
  var hero = document.getElementById("lp-hero");
  var finalCta = root.querySelector(".lp-el__final");
  if (stickybar && hero && "IntersectionObserver" in window) {
    var heroVisible = true;
    var finalVisible = false;

    var heroObs = new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      apply();
    }, { threshold: 0, rootMargin: "0px 0px -40% 0px" });
    heroObs.observe(hero);

    if (finalCta) {
      var finalObs = new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        apply();
      }, { threshold: 0.1 });
      finalObs.observe(finalCta);
    }

    function apply() {
      var shouldShow = !heroVisible && !finalVisible;
      stickybar.classList.toggle("is-visible", shouldShow);
      stickybar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    }
  }
})();
